<template>
   <div>
      <section class="course-review">
         <div class="container">
            <div class="row">
               <div class="col pb-5"><strong>{{$t('course.students_review_about_course')}}</strong></div>
            </div>
            <div class="row">
               <div class="col-sm-12 col-md-4 pt-2">
                  <div class="star-wrapper"> 
                    
  <div class="rating-ptag">
    <span class="library-text"> {{$t('course.ratings')}}
      <span v-if="parseInt($store.getters.getCurrentCourse.rating) == 0">
        <star-rating :rating="parseInt($store.getters.getCurrentCourse.rating)" :read-only=true v-bind:increment="0.5" v-bind:max-rating="5" inactive-color="#96999a" active-color="#ffc000" v-bind:star-size="15">
        </star-rating>
      </span>

      <span v-else>
        <star-rating :rating="parseInt($store.getters.getCurrentCourse.rating.toFixed(1))" :read-only=true v-bind:increment="0.5" v-bind:max-rating="5" inactive-color="#96999a" active-color="#ffc000" v-bind:star-size="15">
        </star-rating>
      </span>
    </span>

  </div>

                  </div>
                  <div class="histo">
                     <div class="histo-rate">
                        <span class="histo-star">
                        5     </span>
                        <span class="bar-block">
                        <span id="bar-five" class="bar">
                        </span> 
                        </span>
                     </div>
                     <div class="four histo-rate">
                        <span class="histo-star">
                        4           </span>
                        <span class="bar-block">
                        <span id="bar-four" class="bar">
                        </span> 
                        </span>
                     </div>
                     <div class="three histo-rate">
                        <span class="histo-star">
                        3           </span>
                        <span class="bar-block">
                        <span id="bar-three" class="bar">
                        </span> 
                        </span>
                     </div>
                     <div class="two histo-rate">
                        <span class="histo-star">
                        2           </span>
                        <span class="bar-block">
                        <span id="bar-two" class="bar">
                        </span> 
                        </span>
                     </div>
                     <div class="one histo-rate">
                        <span class="histo-star">
                        1           </span>
                        <span class="bar-block">
                        <span id="bar-one" class="bar">
                        </span> 
                        </span>
                     </div>
                  </div>
               </div>
               <div class="col-sm-12 col-md-8">
                  <div class="card">
                     <div class="card-swiper">
                        <swiper :options="swiperOptionReview">
                           <swiper-slide v-for="n in 10" :key="n">
                              <div class="row">
                                 <div class="col-md-11 offset-md-1">
                                    <div class="col-md-12">
                                       <div class="row align-items-center">
                                          <div class="col-auto">
                                             <div class="user-img"><img src="/static/assets/images/user.png" width="100" alt="" class="img-responsive"></div>
                                          </div>
                                          <div class="col-md-4 user-name">
                                             <span> Student Name</span><br/>
                                             <small>12 days to go</small> 
                                          </div>
                                          <div class="col">
                                             <div class="rating-star"><i aria-hidden="true" class="mdi mdi-star"></i> <i aria-hidden="true" class="mdi mdi-star"></i> 
                                                <i aria-hidden="true" class="mdi mdi-star"></i> <i aria-hidden="true" class="mdi mdi-star"></i> <i aria-hidden="true" class="mdi mdi-star-half-o"></i> 
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                    <div class="col-md-9 description pt-3">
                                      I absolutely loved it - it was about building blocks and I learned a lot quickly. I also liked how we started simple and built on it.<br>
                                      I did not find the tic-tac and cards assignments that useful - more data oriented assignments could def. be more useful. In general - awesome.
                                    </div>
                                 </div>
                              </div>
                           </swiper-slide>
                        </swiper>
                        <div :options="swiperOptionReview">
                           <div class="swiper-button-prev swiper-review-prev" slot="button-prev"><i class="mdi mdi-chevron-left"></i></div>
                           <div class="swiper-button-next swiper-review-next" slot="button-next"><i class="mdi mdi-chevron-right"></i></div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   </div>
</template>
<script>
import StarRating from 'vue-star-rating'
export default {
  name: 'courseReview',
  components: {StarRating},
  mounted () {
    // alert(JSON.stringify(this.$store.getters.getCurrentCourse))
    // this.$store.dispatch('getCourseDetails', this.$store.getters.getProfileDetails.profileId)
    // alert(JSON.stringify(this.$store.getters.getCourseDetails))
  },
  data: function () {
    return {
      notNextTick: true,
      swiperOptionReview: {
        pagination: '.swiper-pagination',
        nextButton: '.swiper-review-next',
        prevButton: '.swiper-review-prev',
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 30,
        loop: false
      }
    }
  }
}
</script>
<style lang="scss">
.course-review{
padding: 40px 0px 80px 0px;
  .swiper-button-prev{
        margin-left:20px;
        font-size:25px;
        color:#999;
        background-image: none;
    }
    .swiper-button-next{
        margin-right:20px;
        font-size:25px;
        color:#999;
        background-image: none;
    }
.card {
  border:0px;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.18);
    padding: 20px;
  .user-name{
    font-size:14px; line-height:20px;
    small{font-size:11px;}
  }
  .description{
    font-size:12px;
  }
}
.ratingHead{
    font-size: 1.6em; 
    font-weight: bold; 
}
.star-wrapper {
    padding: 0px 0px; text-align: center;
    .fa {
        font-size: 19px;
        color: #ffc000;
    }
}
.histo {
  /*float: left;*/
  width: 100%;
  font-size: 14px; margin:20px 0px; font-weight: 500;  
  .histo-star {
    /*float: left;*/min-width: 20px; text-align: right;
    padding: 0px;
  }
  .histo-rate {
    width: 100%;
    display: flex; flex-direction: row; align-items: center;
    clear: both; padding: 4px 0px; 
  }
  .bar-block {
    margin-left: 5px;
    color: black;
    display: block;
    float: left;
    width: 95%;
    position: relative; padding: 0px 8px;
  }
  .bar {
    padding: 6px;
    display: block;
  }
  #bar-five {
    width: 93%;
    background-color: #f6b330;
  }
  #bar-four {
    width: 70%;
    background-color: #f6b330;
  }
  #bar-three {
    width:60%;
    background-color: #f6b330;
  }
  #bar-two {
    width:30%;
    background-color: #f6b330;
  }
  #bar-one {
    width: 10%;
    background-color: #f6b330;
  }
}
.user-img {img{border-radius: 50%; width:72px;}}
}
</style>



// WEBPACK FOOTER //
// src/components/course/courseReview.vue?a05ee5d2